import ProductsErrorsFactory from '../Errors/factory.js'
import ProductEntity from './ProductEntity.js'

export default class ProductsEntitiesFactory {
  static productEntity = ({
    id,
    name,
    title,
    description,
    discount,
    image,
    recommended,
    price,
    priceBeforeDiscount,
    tax,
    isActive,
    visibility,
    duration
  }) => {
    ProductEntity.validate({
      id,
      title,
      InvalidProductErrorFactory: ProductsErrorsFactory.invalidProductError
    })
    return new ProductEntity({
      id,
      name,
      title,
      description,
      discount,
      image,
      recommended,
      price,
      priceBeforeDiscount,
      tax,
      isActive,
      visibility,
      duration
    })
  }
}
